import React from 'react';
import { Button } from '../../../../Button';
import InfoBox from '../../../../InfoBox/InfoBox';
import { useDataTableQuickActionsContext } from '../../../utils/DataTableQuickActionsContext';
import { useIntlUds } from '../../../../../translations/UdsIntlProvider';
import { DataTableRowAction, DataTableRowActions } from '../../DataTableRowActions';
import { useDataTableQuickReportsContext } from '../../../utils/DataTableQuickReportsContext';
import { AddQuickReportDialog } from '../Dialog/AddQuickReportDialog';

interface QuickReportHasBeenModifiedWarningProps {
  className?: string;
}

export const QuickReportHasBeenModifiedWarning = ({ className }: QuickReportHasBeenModifiedWarningProps) => {
  const { unSavedQuickReport } = useDataTableQuickReportsContext();
  const { setQuickReport, undoChanges, saveCurrentQuickReport, saveAsQuickReport, quickReport } =
    useDataTableQuickActionsContext();
  const { intl } = useIntlUds();
  if (!unSavedQuickReport) {
    return null;
  }
  return (
    <InfoBox
      dataTest="warning-disable-actions"
      type="ALERT"
      className={className}
      title={intl.DataTable.Filters.Content.unSavedQuickView.title}
      actions={
        <>
          <Button dataTest="undo-changes-button" color="primary" onClick={undoChanges}>
            {intl.DataTable.Filters.Content.unSavedQuickView.undoBtn}
          </Button>
          <DataTableRowActions iconSize="small" dataTest="toolbar-undo-changes-button-actions">
            <DataTableRowAction
              dataTest="quick-report-save"
              key="quick-report-save"
              iconName="border_color"
              onClick={saveCurrentQuickReport}
            >
              {intl.DataTable.QuickViews.action.save}
            </DataTableRowAction>
            <DataTableRowAction
              dataTest="quick-report-save-as"
              key="quick-report-save-as"
              iconName="save"
              onClick={() =>
                setQuickReport({
                  name: `CLONE-${unSavedQuickReport.name}`,
                  quickReportId: unSavedQuickReport.quickReportId,
                  actionType: 'Save as'
                })
              }
            >
              {intl.DataTable.QuickViews.action.saveAs}
            </DataTableRowAction>
          </DataTableRowActions>
          <AddQuickReportDialog
            saveQuickReport={quickReport}
            setSaveQuickReport={setQuickReport}
            onSave={saveAsQuickReport}
          />
        </>
      }
    />
  );
};
